import React from 'react';
import { AlertTriangle, Calendar, Clock, CheckCircle } from 'lucide-react';
import { QuickStatsCard } from '@features/cx/shared/components/QuickStatsCard';
import { getRemoteUtilityId } from '@shared/utils/getUtilityId';
import { useConsumerSummary } from '../../hooks';

export const Summary: React.FC = () => {
  const remoteUtilityId = getRemoteUtilityId();
  const { data: summaryData } = useConsumerSummary({
    remoteUtilityId: remoteUtilityId,
    activeTab: "Consumer_Onboarding",
  });


  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <QuickStatsCard 
        title="Applications Pending"
        count={summaryData?.applicationPending}
        trendSummary="No trend data available"
        trendDirection="up"
        icon={<AlertTriangle className="h-8 w-8 text-amber-500" />}
      />
      <QuickStatsCard 
        title="Approved Today"
        count={summaryData?.approvedToday}
        trendSummary="No trend data available"
        trendDirection="up"
        icon={<Calendar className="h-8 w-8 text-blue-500" />}
      />
      <QuickStatsCard 
        title="Avg. Processing Time"
        count={summaryData?.avgProcessingTime}
        trendSummary="No trend data available"
        trendDirection="up"
        icon={<Clock className="h-8 w-8 text-red-500" />}
      />
      <QuickStatsCard 
        title="Rejection Rate"
        count={summaryData?.rejectionRate}
        trendSummary="No trend data available"
        trendDirection="up"
        icon={<CheckCircle className="h-8 w-8 text-green-500" />}
      />
    </div>
  );
};
